import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-168838a0")

_pushScopeId("data-v-168838a0")
const _hoisted_1 = { class: "top-tit" }
const _hoisted_2 = { class: "wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1)
  ]))
})